<template>
  <div class="app-voucherbox" :class="colour" v-if="isActive && voucherCodeText">
    <SimonModal
      :is-visible="showInfoModal"
      @hide="showInfoModal = false"
    >
      <template v-slot:modalTitle>
        <h2>{{ voucherCodeText }}</h2>
      </template>
      <div v-html="processHTML(txtInfoModal)"></div>
    </SimonModal>
    <div class="box--info">
      <div class="box--heading">
        <h3 v-html="processHTML(`${txtPre} ${voucherCodeText}`)"></h3>
        <button v-if="hasInfoIcon" @click="openInfoModal()" class="icon-only" type="button" :aria-label="lblInfoIcon"><img height="20" width="20" alt="" :src="colour === 'fill-white' ? 'files/flash/images/svg-icons/info-icon.svg' : 'files/flash/images/svg-icons/info-icon-white.svg'" aria-hidden="true"></button>
      </div>
      <div v-html="processHTML(txtDescription)"></div>
    </div>
    <div class="btn-wrapper">
      <button v-if="!voucherRedeemed" type="button" class="outline" @click="handleVoucherClick(voucherCodeText)" :aria-label="lblButton">{{ btnText }}</button>
      <span v-else class="redeemed">{{ voucherRedeemedText }}</span>
    </div>
  </div>
</template>
<script>

import voucherConfig from '@/mixins/voucherConfig'
import trackingHandler from '@/mixins/trackingHandler'
import SimonModal from '@/components/modal/SimonModal.vue'
import date from '@/mixins/validators/date'
export default {
  name: 'TariffVoucherBox',
  components: {
    SimonModal
  },
  mixins: [
    voucherConfig,
    trackingHandler,
    date
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    colour: {
      type: String,
      default: ''
    },
    voucherCodeText: {
      type: String,
      default: ''
    },
    txtPre: {
      type: String,
      default: ''
    },
    txtDescription: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    voucherRedeemedText: {
      type: String,
      default: ''
    },
    voucherCodeRedeemedToast: {
      type: String,
      default: ''
    },
    hasInfoIcon: {
      type: String,
      default: ''
    },
    lblInfoIcon: {
      type: String,
      default: ''
    },
    lblButton: {
      type: String,
      default: ''
    },
    txtInfoModal: {
      type: String,
      default: ''
    },
    startDate: {
      type: [Number, String],
      default: 0
    },
    endDate: {
      type: [Number, String],
      default: 0
    },
    autoRedeemVoucher: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      showInfoModal: false,
      voucherRedeemed: false
    }
  },
  mounted () {
    if (this.autoRedeemVoucher) {
      this.redeemVoucher()
    }
    if (this.voucherCode === this.voucherCodeText) {
      this.voucherRedeemed = true
    }
  },
  computed: {
    isActive () {
      return this.todayIsBetweenDates(this.startDate, this.endDate)
    },
    voucherCode () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/voucherCode']
    }
  },
  methods: {
    redeemVoucher () {
      const checkoutCta = document.querySelector('[data-prid=\'button-checkout\']')
      if (checkoutCta) {
        const url = new URL(checkoutCta.href)
        const urlParams = new URLSearchParams(url.search)

        urlParams.set('promoCode', this.voucherCodeText)
        checkoutCta.href = url.origin + url.pathname + '?' + urlParams.toString()
        this.voucherRedeemed = true
      }
    },
    handleVoucherClick () {
      this.redeemVoucher()
      this.successToast(this.voucherCodeRedeemedToast)
    },
    openInfoModal (token = this.getSlotText('voucherCode')) {
      this.showInfoModal = true
      this.trackData('information', {
        information_action: 'reveal',
        information_name: token.toLowerCase() + ' info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      })
    }
  }
}
</script>
